import React from 'react';

const kvIbSizes={sm:{width:32,height:32},md:{width:40,height:40},lg:{width:48,height:48}};
const kvIbVariants={
  ghost:{background:'transparent',color:'var(--text-muted)',borderColor:'transparent'},
  secondary:{background:'var(--white)',color:'var(--text-body)',borderColor:'var(--border-default)'},
  primary:{background:'var(--surface-brand)',color:'var(--white)',borderColor:'var(--surface-brand)'},
  soft:{background:'var(--surface-brand-soft)',color:'var(--burgundy-800)',borderColor:'transparent'}
};

export function IconButton({variant='ghost',size='md',label,disabled=false,active=false,onClick,style,children,...rest}){
  const [hover,setHover]=React.useState(false);
  const s={display:'inline-flex',alignItems:'center',justifyContent:'center',border:'1px solid transparent',borderRadius:'var(--radius-control)',cursor:disabled?'not-allowed':'pointer',transition:'var(--transition-control)',padding:0,
    ...kvIbSizes[size],...kvIbVariants[variant],
    ...(active?{background:'var(--surface-brand-soft)',color:'var(--burgundy-800)'}:null),
    ...(hover&&!disabled?{background:variant==='primary'?'var(--surface-brand-hover)':'var(--ink-50)',color:variant==='primary'?'var(--white)':'var(--text-strong)'}:null),
    opacity:disabled?0.45:1,...style};
  return React.createElement('button',{type:'button','aria-label':label,title:label,disabled,onClick,style:s,onMouseEnter:()=>setHover(true),onMouseLeave:()=>setHover(false),...rest},children);
}
